(() => {
  'use strict';

  // --- Config ---
  const COOKIE_NAME = 'check_tax';
  const COOKIE_DAYS = 5;
  const DEFAULT_STATE = 'without_tax'; // 'with_tax' | 'without_tax'
  const SEL = {
    toggle: 'input.tax-setting',
    btnWith: '#set-with-tax',
    btnWithout: '#set-without-tax',
    popup: '#tax-pop__container',
    priceLists: '.price-list',
    loaders: '.loader',
  };

  // --- Cookie utils ---
  const getCookie = (name) => {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([$?*|{}\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  };

  const setCookie = (name, value, days = COOKIE_DAYS) => {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`;
  };

  // --- DOM helpers ---
  const qs  = (s, ctx = document) => ctx.querySelector(s);
  const qsa = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));

  const showPopup = () => { const pop = qs(SEL.popup);   if (pop) pop.style.display = 'flex'; };
  const hidePopup = () => { const pop = qs(SEL.popup);   if (pop) pop.style.display = 'none'; };

  const removeLoader = () => {
    qsa(SEL.priceLists).forEach(e => { e.style.display = 'block'; });
    qsa(SEL.loaders).forEach(e => { e.style.display = 'none'; });
  };

  // --- Apply state to <body> + sync toggle UI ---
  const applyState = (state) => {
    const b = document.body;
    b.classList.toggle('tax-with',     state === 'with_tax');
    b.classList.toggle('tax-without',  state === 'without_tax');
    const toggle = qs(SEL.toggle);
    if (toggle) toggle.checked = (state === 'with_tax');
  };

  // --- Core: set + apply ---
  const setAndApply = (state, from) => {
    const finalState = (state === 'with_tax' || state === 'without_tax') ? state : DEFAULT_STATE;
    setCookie(COOKIE_NAME, finalState, COOKIE_DAYS);
    applyState(finalState);
    if (from !== 'initial') hidePopup();
    removeLoader();
  };

  // --- Init flow ---
  const initOnceFlag = '__tax_toggle_wired__';

  const init = (source = 'initial') => {
    const current = getCookie(COOKIE_NAME);

    if (!current) {
      if (source === 'initial') {
        showPopup();
        applyState(DEFAULT_STATE);
        removeLoader();
        return;
      }
    }

    if (source === 'initial' && current) {
      applyState(current);
      removeLoader();
      return;
    }

    let next = current;
    if (source === 'with_tax' || source === 'without_tax') {
      next = source;
    } else {
      const toggle = qs(SEL.toggle);
      if (toggle) next = toggle.checked ? 'with_tax' : 'without_tax';
    }
    setAndApply(next || DEFAULT_STATE, source);
  };

  // --- Wire UI events (idempotent) ---
  const wire = () => {
    if (document[initOnceFlag]) return;
    document[initOnceFlag] = true;

    const btnWith   = qs(SEL.btnWith);
    const btnWithout= qs(SEL.btnWithout);
    const toggle    = qs(SEL.toggle);

    if (btnWith)    btnWith.addEventListener('click',  () => init('with_tax'));
    if (btnWithout) btnWithout.addEventListener('click',() => init('without_tax'));
    if (toggle)     toggle.addEventListener('change',  () => init(toggle.checked ? 'with_tax' : 'without_tax'));
  };

  // --- Optional: your layout tweak ---
  function appendJsFilterTree() {
    const jsFilters = document.getElementById('gf-tree');
    const propFilter = document.querySelector('.gf-tree.prop');
    const bannerHead = document.querySelector('.collection');

    if (jsFilters && bannerHead) {
      bannerHead.appendChild(jsFilters);
      jsFilters.style.display = "block";
      jsFilters.style.width = "20%";
      jsFilters.style.marginRight = "40px";
      jsFilters.style.minWidth = "20%";
      if (propFilter) propFilter.style.display = "none";
    } else {
      if (propFilter) propFilter.style.display = "none";
      console.log('One or both main elements were not found');
    }
  }

  // --- Event hooks + pagination awareness ---

  // Debounce init
  let _initTimer = null;
  const scheduleInit = (why = 'event') => {
    if (_initTimer) cancelAnimationFrame(_initTimer);
    _initTimer = requestAnimationFrame(() => {
      console.debug('[TaxToggle] re-init due to:', why);
      wire();
      init('initial');
    });
  };

  // 1) Globo events (filter/sort/pagination); also re-arm observer
  ['globoFilterRenderCompleted', 'globoFilterAfterRequest', 'globoFilterPageLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
      startProductsObserver();
      scheduleInit(ev);
    });
  });

  // 2) Observe product grid mutations
  const PRODUCT_ROOT_SELECTORS = [
    '#gf-products',
    '.gf-products',
    '.gf-grid',
    '.collection .grid',
    '[data-globo-products]',
    'product-list'
  ];

  let productsObserver = null;

  const getFirstEl = (selectors) => {
    for (const s of selectors) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  };

  const startProductsObserver = () => {
    const root = getFirstEl(PRODUCT_ROOT_SELECTORS);
    if (!root) return;
    if (productsObserver) productsObserver.disconnect();

    productsObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length || m.removedNodes.length) {
          scheduleInit('mutation');
          break;
        }
      }
    });

    productsObserver.observe(root, { childList: true, subtree: true });
    console.debug('[TaxToggle] observing products at', root);
  };

  // 3) History API + back/forward
  (() => {
    const dispatchLocationChange = () => window.dispatchEvent(new Event('locationchange'));
    const { pushState, replaceState } = history;
    history.pushState = function () {
      const r = pushState.apply(this, arguments);
      queueMicrotask(dispatchLocationChange);
      return r;
    };
    history.replaceState = function () {
      const r = replaceState.apply(this, arguments);
      queueMicrotask(dispatchLocationChange);
      return r;
    };
    window.addEventListener('popstate', dispatchLocationChange);
  })();

  window.addEventListener('locationchange', () => {
    startProductsObserver(); // grid may be replaced
    scheduleInit('locationchange');
  });

  // 4) Delegated pager clicks (covers non-standard triggers)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.gf-pagination a, .pagination a, a[href*="page="], a[data-page], button[data-page]');
    if (a) setTimeout(() => scheduleInit('pager-click'), 0);
  });

  // Initial page load
  window.addEventListener('load', () => {
    wire();
    init('initial');
    appendJsFilterTree?.();
    startProductsObserver();
  });

  // Debug API
  window.TaxPriceToggle = {
    apply: applyState,
    set: (state) => setAndApply(state),
    get: () => getCookie(COOKIE_NAME),
  };
})();